// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

// FIXME: TypeScript and Webpack can resolve exports from the package.json
// `exports` field but Rollup can't. `@quartzds/generic-icons-core/*.svg`
// _should_ work but it doesn't.
/* eslint-disable import/no-unresolved */
import checked from '@quartzds/generic-icons-core/dist/checked.svg'
import draggable from '@quartzds/generic-icons-core/dist/draggable.svg'
import dropdown from '@quartzds/generic-icons-core/dist/dropdown.svg'
import dropdownClose from '@quartzds/generic-icons-core/dist/dropdown-close.svg'
import externalLink from '@quartzds/generic-icons-core/dist/external-link.svg'
import indeterminate from '@quartzds/generic-icons-core/dist/indeterminate.svg'
import navigation from '@quartzds/generic-icons-core/dist/navigation.svg'
import next from '@quartzds/generic-icons-core/dist/next.svg'
import statusError from '@quartzds/generic-icons-core/dist/status-error.svg'
import statusInfo from '@quartzds/generic-icons-core/dist/status-info.svg'
import statusWarning from '@quartzds/generic-icons-core/dist/status-warning.svg'

/* eslint-enable import/no-unresolved */
import type { IconLibrary } from './library'

const icons: Record<string, string | undefined> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  checked,
  draggable,
  dropdown,
  'dropdown-close': dropdownClose,
  'external-link': externalLink,
  indeterminate,
  navigation,
  next,
  close: statusError,
  'status-error': statusError,
  'status-info': statusInfo,
  'status-success': checked,
  'status-warning': statusWarning,
  /* eslint-enable @typescript-eslint/naming-convention */
}

const coreLibrary: IconLibrary = {
  name: 'core',
  resolver: (name) => icons[name] ?? '',
}

export default coreLibrary
